import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal, Box } from "@mui/material"
import ChatGPT from "../../AI/ChatGPT/ChatGPT"
import styles from "../Modals.module.css"
import ModalCloseButton from "../ModalCloseButton"

const AIModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <>
        <ModalCloseButton handleClose={handleClose} />
        <Box className={styles.modal_container}>
          <ChatGPT />
        </Box>
      </>
    </Modal>
  )
})

export default AIModal
